import {RestResource} from '../rest'

import { ASSET_SERVER } from '../server'
import {athubAxios} from "@/util/athub-axios";

const assetAttribute = new RestResource({server: ASSET_SERVER, resource: 'assetattribute'});
assetAttribute._allUrl = [assetAttribute.server, assetAttribute.resource, 'all'].join('/');
assetAttribute.all = function(search, athubConfig) {
  return athubAxios.post(assetAttribute._allUrl, search, athubConfig);
};
export default assetAttribute;

